module.exports = __webpack_public_path__ + "img/279-dd910d.png";